import { Injectable } from '@angular/core';
import { BaseService } from '../BaseService';

@Injectable({
  providedIn: 'root',
})
export class OriginalService extends BaseService {

  protected urlPath = '/v1/archive-messages';

  getOriginal(id) {
    return this._http.get(this.getFullUrl(`${id}/original`));
  }

}
